export const initialState = {
  actionProcessing: false,
  points: {
    myPoints: null,
    cashiersList: [],
  },
  superadminBonusSistemProcessing: false,
  superadminBonusSistemLoaded: false,
  superadminBonusSistemLoadFinished: false,
  superadminBonusSistem: {
    period: '2026-06',
    currentGrade: {
      id: 'bronze',
      name: 'Bronze',
      minDepositUsdt: 0,
      depositBonusPercent: 0.3,
      transitionBonusUsd: 0,
      nextLevelDepositUsdt: 300,
    },
    nextGrade: {
      id: 'silver',
      name: 'Silver',
      minDepositUsdt: 300,
      depositBonusPercent: 0.5,
      transitionBonusUsd: 5,
      nextLevelDepositUsdt: 1000,
    },
    amountDepositsLast30Days: 0,
    remainingToNextUsdt: 0,
    progressToNextLevelPercent: 0,
    paidTransitionGrades: [],
    updatedAt: null,
  },
};
